<script lang="ts">
  import type { ApiField } from '../../data-tables-api';

  let {
    field,
    value,
    onChange,
    error,
    disabled = false,
  }: {
    field: ApiField;
    value: unknown;
    onChange: (v: unknown) => void;
    error?: string | null;
    disabled?: boolean;
  } = $props();

  const stringValue = $derived(value != null ? String(value) : '');
  const options = $derived(field.options ?? []);
</script>

{#if options.length === 0}
  <div class="rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-[11px] text-amber-800">
    Список варіантів пустий — задайте options у Settings → Структура даних.
  </div>
{:else}
  <select
    value={stringValue}
    onchange={(e) => onChange((e.target as HTMLSelectElement).value || null)}
    required={field.required}
    {disabled}
    class="w-full rounded-md border bg-white px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[var(--color-pu)] {error ? 'border-red-400' : 'border-[var(--color-border-3)]'}"
  >
    <option value="">{field.required ? '— оберіть —' : '— не задано —'}</option>
    {#each options as opt (opt)}
      <option value={opt}>{opt}</option>
    {/each}
  </select>
{/if}
{#if error}
  <div class="mt-1 text-[11px] text-red-600">{error}</div>
{/if}
